import { withPending, withRejected, withFulFilled } from "./commons";
import loadColorPickerColorsFromLocalStorage from "../../util/colorPicker/loadColorPickerColorsFromLocalStorage";
import { getDefaultChartConfigDataPayload } from "../models/chartConfig";

import {
  FETCH_SIMPLE_CHART_DATA,
  FETCH_SIMPLE_CROSS_CHART_DATA,
  FETCH_EVOLUTIVE_CHART_DATA,
  FETCH_MULTI_CROSS_CHART_DATA,
  FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA,
  UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA,
  UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA,
  FETCH_CORRELATION_CHART_DATA,
  FETCH_SIMULATION_CHART_DATA,
  FETCH_PREDICT_EVOLUTIVE_CHART_DATA,
  CALCULATE_SIMULATION_CHART_DATA,
  FETCH_SIMPLE_CHART_COLOR_CONFIG_DATA,
  UPDATE_CHART_COLOR_CONFIG_DATA,
  UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA,
  UPDATE_SIMPLE_CHART_COLOR_SCHEME,
  UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME,
  UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA,
  FETCH_EVOLUTIVE_CHART_CONFIG_DATA,
  FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA,
  UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA,
  UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME,
  FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA,
  UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA,
  UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA,
  UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME,
  UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA,
  UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA,
  UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME,
  FETCH_CORRELATION_CHART_CONFIG_DATA,
  UPDATE_CORRELATION_COLOR_CONFIG_DATA,
  UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA,
  UPDATE_CORRELATION_CHART_COLOR_SCHEME,
} from "../actions/charts";

const colorConfigErrorMessage =
  "Instabilidade no sistema, algumas funções não estão funcionando.";

// Simple cross chart config data (GET)
function fetchSimpleCrossChartColorConfigDataPending(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      apiHasNoConfigs: false,
      running: true,
      error: false,
    },
  };
}

// caso tenha erro ao carregar os dados da API, carrega as cores padrão do tema
function fetchSimpleCrossChartColorConfigDataRejected(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: false,
      error: colorConfigErrorMessage,
      apiHasNoConfigs: false,
      payload: {
        ...getDefaultChartConfigDataPayload(),
      },
      fetchedPayload: {
        ...getDefaultChartConfigDataPayload(),
      },
    },
  };
}

// se obtiver sucesso, carrega as configurações, se vier vazio, mesmo dando sucesso
// (nos casos em que nunca foi configurada cores)
// atualiza os dados carregados para uma versão onde tem as cores padrão do tema escolhido
function fetchSimpleCrossChartColorConfigDataFulFilled(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: false,
      error: false,
      apiHasNoConfigs: !action.payload.data.data,
      payload: action.payload.data.data
        ? {
            ...action.payload.data.data,
            chartsColors: {
              ...action.payload.data.data.chartsColors,
            },
            colorSchemeValue:
              action.payload.data.data.colorSchemeValue || "standard",
          }
        : {
            ...getDefaultChartConfigDataPayload(),
          },
      fetchedPayload: action.payload.data.data
        ? {
            ...action.payload.data.data,
            chartsColors: {
              ...action.payload.data.data.chartsColors,
            },
            colorSchemeValue:
              action.payload.data.data.colorSchemeValue || "standard",
          }
        : {
            ...getDefaultChartConfigDataPayload(),
          },
    },
  };
}

// Atualização das configurações de cores dos graficos de cruzamento simples
// na API
function updateSimpleCrossChartDataPending(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: true,
      error: false,
    },
  };
}

// Caso tenha erro, deve retornar o estado para a versao inicial
// quando carregou da API
function updateSimpleCrossChartDataRejected(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: false,
      error: action.payload,
      payload: {
        ...state.simpleCrossChartConfigData.fetchedPayload,
        chartsColors: {
          ...state.simpleCrossChartConfigData.fetchedPayload.chartsColors,
        },
      },
    },
  };
}

// Caso obtenha sucesso, deve salvar a nova ordem de cores do colorpicker
// além de atualizar os dados carregados da api com o estado da alteração
// que foi enviado para a API
function updateSimpleCrossChartDataFulfulled(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: false,
      error: false,
      // Setando a flag que retorna a informacao se o usuario ja configurou esse gráfico na API antes
      apiHasNoConfigs: false,
      // aqui ele atualiza as cores carregadas da api com a nova configuracao de cores
      // que foi submetida para lá
      payload: {
        ...action.payload.newData,
        chartsColors: { ...action.payload.newData.chartsColors },
      },
      fetchedPayload: {
        ...action.payload.newData,
        chartsColors: { ...action.payload.newData.chartsColors },
      },
      // aqui ele atualiza as cores do colorpicker com o novo array de cores ordenado
      // de acordo com as ultimas seleções
      colorPickerColors: action.payload.newColorsArray,
    },
  };
}

// Atualização da configuração de fonte na API
function updateSimpleCrossChartFontSizePending(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: true,
      error: false,
    },
  };
}

// Caso haja falha ao carregar a fonte na API, não deve atualizar o estado
// do payload, apenas o de erro e o boolean que sinaliza que parou de carregar
function updateSimpleCrossChartFontSizeRejected(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: false,
      error: action.payload,
    },
  };
}
// caso obtenha sucesso, ele atualiza o estado das fontes
function updateSimpleCrossChartFontSizeFulfilled(state, action) {
  return {
    ...state,
    simpleCrossChartConfigData: {
      ...state.simpleCrossChartConfigData,
      running: false,
      error: false,
      apiHasNoConfigs: false,
      // Atualizando os payloads com as novas configurações de fonte.
      fetchedPayload: {
        ...state.simpleCrossChartConfigData.fetchedPayload,
        fontsSizes: action.payload.newFontsSizes,
      },
      payload: {
        ...state.simpleCrossChartConfigData.payload,
        fontsSizes: action.payload.newFontsSizes,
      },
    },
  };
}

// Funções de atualização do store das actions de carregamento de dados de configuração dos gráficos de gruzamento multiplo
function fetchMultiCrossingChartConfigDataPending(state, action) {
  return {
    ...state,
    multiCrossChartConfigData: {
      ...state.multiCrossChartConfigData,
      error: false,
      running: true,
    },
  };
}

function fetchMultiCrossingChartConfigDataFulfilled(state, action) {
  return {
    ...state,
    multiCrossChartConfigData: {
      ...state.multiCrossChartConfigData,
      error: false,
      running: false,
      apiHasNoConfigs: !action.payload.data.data,
      payload: action.payload.data.data
        ? {
            ...action.payload.data.data,
            chartsColors: {
              ...action.payload.data.data.chartsColors,
            },
            colorSchemeValue:
              action.payload.data.data.colorSchemeValue || "standard",
          }
        : {
            ...getDefaultChartConfigDataPayload(),
          },
      fetchedPayload: action.payload.data.data
        ? {
            ...action.payload.data.data,
            chartsColors: {
              ...action.payload.data.data.chartsColors,
            },
            colorSchemeValue:
              action.payload.data.data.colorSchemeValue || "standard",
          }
        : {
            ...getDefaultChartConfigDataPayload(),
          },
    },
  };
}

function fetchMultiCrossingChartConfigDataRejected(state, action) {
  return {
    ...state,
    multiCrossChartConfigData: {
      ...state.multiCrossChartConfigData,
      running: false,
      error: colorConfigErrorMessage,
      payload: getDefaultChartConfigDataPayload(),
      fetchedPayload: getDefaultChartConfigDataPayload(),
    },
  };
}

// Atualização das configurações de cores dos graficos de cruzamento múltiplo
// na API
function updateMultipleCrossChartDataPending(state, action) {
  return {
    ...state,
    multiCrossChartConfigData: {
      ...state.multiCrossChartConfigData,
      running: true,
      error: false,
    },
  };
}

// Caso tenha erro, deve retornar o estado para a versao inicial
// quando carregou da API
function updateMultipleCrossChartDataRejected(state, action) {
  return {
    ...state,
    multiCrossChartConfigData: {
      ...state.multiCrossChartConfigData,
      running: false,
      error: action.payload,
      payload: {
        ...state.multiCrossChartConfigData.fetchedPayload,
        chartsColors: {
          ...state.multiCrossChartConfigData.fetchedPayload.chartsColors,
        },
      },
    },
  };
}

// Caso obtenha sucesso, deve salvar a nova ordem de cores do colorpicker
// além de atualizar os dados carregados da api com o estado da alteração
// que foi enviado para a API
function updateMultipleCrossChartDataFulfulled(state, action) {
  return {
    ...state,
    multiCrossChartConfigData: {
      ...state.multiCrossChartConfigData,
      running: false,
      error: false,
      // Setando a flag que retorna a informacao se o usuario ja configurou esse gráfico na API antes
      apiHasNoConfigs: false,
      // aqui ele atualiza as cores carregadas da api com a nova configuracao de cores
      // que foi submetida para lá
      payload: {
        ...action.payload.newData,
        chartsColors: { ...action.payload.newData.chartsColors },
      },
      fetchedPayload: state.multiCrossChartConfigData.payload,
      // aqui ele atualiza as cores do colorpicker com o novo array de cores ordenado
      // de acordo com as ultimas seleções
      colorPickerColors: action.payload.newColorsArray,
    },
  };
}

// initial states
const INITIAL_STATE = {
  chartConfigData: {
    running: false,
    error: null,
    apiHasNoConfigs: false,
    // gerado a partir do carregamento das configurações dos gráficos simples da API,
    // para no momento subsequente gerenciar localmente as configurações dos gráficos
    // (cores e fontes)
    payload: { ...getDefaultChartConfigDataPayload() },
    // cores carregadas da api
    fetchedPayload: { ...getDefaultChartConfigDataPayload() },
    // caso não haja cores memorizadas do colorpicker no localstorage, ele inicializa
    // o array com essas cores
    colorPickerColors: loadColorPickerColorsFromLocalStorage("simpleChart") || [
      "#F257E8",
      "#FF7051",
      "#6A00FF",
      "#FFBEE8",
      "#F24444",
      "#00BEC1",
      "#FFBA00",
    ],
  },
  simpleChartData: {
    running: false,
    error: null,
    payload: [],
  },
  simpleCrossChartData: {
    running: false,
    error: null,
    payload: [],
  },
  simpleCrossChartConfigData: {
    running: false,
    error: null,
    apiHasNoConfigs: false,
    // estado intermediario antes de submeter as alterações de configuração para a API
    payload: { ...getDefaultChartConfigDataPayload() },
    // configuraçoes carregadas da API
    fetchedPayload: { ...getDefaultChartConfigDataPayload() },
    // caso não haja cores memorizadas do colorpicker no localstorage, ele inicializa
    // o array com essas cores
    colorPickerColors: loadColorPickerColorsFromLocalStorage(
      "simpleCrossChart"
    ) || [
      "#F257E8",
      "#FF7051",
      "#6A00FF",
      "#FFBEE8",
      "#F24444",
      "#00BEC1",
      "#FFBA00",
    ],
  },
  multiCrossChartData: {
    running: false,
    error: null,
    payload: [],
  },
  multiCrossChartConfigData: {
    running: false,
    error: null,
    apiHasNoConfigs: false,
    // estado intermediario antes de submeter as alterações de configuração para a API
    payload: getDefaultChartConfigDataPayload(),
    // configuraçoes carregadas da API
    fetchedPayload: getDefaultChartConfigDataPayload(),
    // caso não haja cores memorizadas do colorpicker no localstorage, ele inicializa
    // o array com essas cores
    colorPickerColors: loadColorPickerColorsFromLocalStorage(
      "multipleCross"
    ) || [
      "#F257E8",
      "#FF7051",
      "#6A00FF",
      "#FFBEE8",
      "#F24444",
      "#00BEC1",
      "#FFBA00",
    ],
  },
  evolutiveChartConfigData: {
    running: false,
    error: null,
    apiHasNoConfigs: false,
    // gerado a partir do carregamento das configurações dos gráficos simples da API,
    // para no momento subsequente gerenciar localmente as configurações dos gráficos
    // (cores e fontes)
    payload: getDefaultChartConfigDataPayload(),
    // cores carregadas da api
    fetchedPayload: getDefaultChartConfigDataPayload(),
    // caso não haja cores memorizadas do colorpicker no localstorage, ele inicializa
    // o array com essas cores
    colorPickerColors: loadColorPickerColorsFromLocalStorage(
      "evolutiveChart"
    ) || [
      "#F257E8",
      "#FF7051",
      "#6A00FF",
      "#FFBEE8",
      "#F24444",
      "#00BEC1",
      "#FFBA00",
    ],
  },
  evolutiveCrossChartConfigData: {
    running: false,
    error: null,
    apiHasNoConfigs: false,
    // gerado a partir do carregamento das configurações dos gráficos simples da API,
    // para no momento subsequente gerenciar localmente as configurações dos gráficos
    // (cores e fontes)
    payload: getDefaultChartConfigDataPayload(),
    // cores carregadas da api
    fetchedPayload: getDefaultChartConfigDataPayload(),
    // caso não haja cores memorizadas do colorpicker no localstorage, ele inicializa
    // o array com essas cores
    colorPickerColors: loadColorPickerColorsFromLocalStorage(
      "evolutiveCrossChart"
    ) || [
      "#F257E8",
      "#FF7051",
      "#6A00FF",
      "#FFBEE8",
      "#F24444",
      "#00BEC1",
      "#FFBA00",
    ],
  },
  evolutionCrossChartData: {
    running: false,
    error: null,
    payload: [],
  },
  evolutionChartData: {
    running: false,
    error: null,
    payload: [],
  },
  correlationChartData: {
    running: false,
    error: null,
    type: null,
    payload: [],
  },
  correlationChartConfigData: {
    running: false,
    error: null,
    apiHasNoConfigs: false,
    // gerado a partir do carregamento das configurações de cores do gráfico de correlação,
    // indexado pelo enunciado da pergunta correlacionada
    payload: getDefaultChartConfigDataPayload(),
    // cores carregadas da api (snapshot, usado para rollback em caso de erro de update)
    fetchedPayload: getDefaultChartConfigDataPayload(),
    // caso não haja cores memorizadas do colorpicker no localstorage, ele inicializa
    // o array com essas cores
    colorPickerColors: loadColorPickerColorsFromLocalStorage(
      "correlationChart"
    ) || [
      "#F257E8",
      "#FF7051",
      "#6A00FF",
      "#FFBEE8",
      "#F24444",
      "#00BEC1",
      "#FFBA00",
    ],
  },
  simulationChartData: {
    running: false,
    error: null,
    payload: null, // {id: int, enunciado: string, alternativas:[], perguntas_correlacionadas: []}
  },
  predictiveChartData: {
    running: false,
    error: null,
    payload: null, // {id: int, enunciado: string, alternativas:[], perguntas_correlacionadas: []}
  },
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // REDUCER DE UPDATE DE CONFIGURAÇÃO DA OPÇÃO DO COLOR SCHEME DO GRÁFICO SIMPLES
    case withPending(UPDATE_SIMPLE_CHART_COLOR_SCHEME):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          running: true,
          error: false,
        },
      };
    case withFulFilled(UPDATE_SIMPLE_CHART_COLOR_SCHEME):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.chartConfigData.payload,
            chartsColors: action.payload.newChartsColors,
            colorSchemeValue: action.payload.newColorScheme,
          },
        },
      };
    case withRejected(UPDATE_SIMPLE_CHART_COLOR_SCHEME):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          running: false,
          error: action.payload,
        },
      };
    // REDUCER DE UPDATE DE CONFIGURAÇÃO DA OPÇÃO DO COLOR SCHEME DO GRÁFICO DE CRUZAMENTO SIMPLES
    case withPending(UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        simpleCrossChartConfigData: {
          ...state.simpleCrossChartConfigData,
          running: true,
          error: false,
        },
      };
    case withFulFilled(UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        simpleCrossChartConfigData: {
          ...state.simpleCrossChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.simpleCrossChartConfigData.payload,
            chartsColors: action.payload.newChartsColors,
            colorSchemeValue: action.payload.newColorScheme,
          },
        },
      };
    case withRejected(UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        simpleCrossChartConfigData: {
          ...state.simpleCrossChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    // REDUCER DE UPDATE DE CONFIGURAÇÃO DA OPÇÃO DO COLOR SCHEME DO GRÁFICO DE CRUZAMENTO MÚLTIPLO
    case withPending(UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        multiCrossChartConfigData: {
          ...state.multiCrossChartConfigData,
          running: true,
          error: false,
        },
      };
    case withFulFilled(UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        multiCrossChartConfigData: {
          ...state.multiCrossChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.multiCrossChartConfigData.payload,
            chartsColors: action.payload.newChartsColors,
            colorSchemeValue: action.payload.newColorScheme,
          },
        },
      };
    case withRejected(UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        multiCrossChartConfigData: {
          ...state.multiCrossChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    // REDUCER DE UPDATE DE CONFIGURAÇÃO DA OPÇÃO DO COLOR SCHEME DO GRÁFICO EVOLUTIVO
    case withPending(UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: true,
          error: false,
        },
      };
    case withFulFilled(UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.evolutiveChartConfigData.payload,
            chartsColors: action.payload.newChartsColors,
            colorSchemeValue: action.payload.newColorScheme,
          },
        },
      };
    case withRejected(UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    // REDUCER DE UPDATE DE CONFIGURAÇÃO DA OPÇÃO DO COLOR SCHEME DO CARD EVOLUTIVO DE CRUZAMENTOS
    case withPending(UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: true,
          error: false,
        },
      };
    case withFulFilled(UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.evolutiveCrossChartConfigData.payload,
            chartsColors: action.payload.newChartsColors,
            colorSchemeValue: action.payload.newColorScheme,
          },
        },
      };
    case withRejected(UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    /**
     * Carregando configuração de fontes de gráfico de cruzamento simples
     */
    case withPending(UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        multiCrossChartConfigData: {
          ...state.multiCrossChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        multiCrossChartConfigData: {
          ...state.multiCrossChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    case withFulFilled(UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        multiCrossChartConfigData: {
          ...state.multiCrossChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.multiCrossChartConfigData.payload,
            fontsSizes: action.payload.newFontsSizes,
          },
        },
      };

    /**
     * update das configurações de cores do gráfico evolutivo
     */
    case withPending(UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: true,
          error: false,
        },
      };

    case withRejected(UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: false,
          error: action.payload,
          payload: {
            ...state.evolutiveChartConfigData.fetchedPayload,
            chartsColors: {
              ...state.evolutiveChartConfigData.fetchedPayload.chartsColors,
            },
          },
        },
      };
    case withFulFilled(UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: false,
          error: false,
          apiHasNoConfigs: false,
          payload: {
            ...action.payload.newData,
            chartsColors: { ...action.payload.newData.chartsColors },
          },
          fetchedPayload: state.evolutiveChartConfigData.payload,
          colorPickerColors: action.payload.newColorsArray,
        },
      };

    /**
     * Fetch das configurações do gráfico evolutivo
     */
    case withPending(FETCH_EVOLUTIVE_CHART_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(FETCH_EVOLUTIVE_CHART_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: false,
          error: colorConfigErrorMessage,
          payload: getDefaultChartConfigDataPayload(),
          fetchedPayload: getDefaultChartConfigDataPayload(),
        },
      };
    case withFulFilled(FETCH_EVOLUTIVE_CHART_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          error: false,
          running: false,
          apiHasNoConfigs: !action.payload.data.data,
          payload: action.payload.data.data
            ? {
                ...action.payload.data.data,
                chartsColors: {
                  ...action.payload.data.data.chartsColors,
                },
                colorSchemeValue:
                  action.payload.data.data.colorSchemeValue || "standard",
              }
            : getDefaultChartConfigDataPayload(),
          fetchedPayload: action.payload.data.data
            ? {
                ...action.payload.data.data,
                chartsColors: {
                  ...action.payload.data.data.chartsColors,
                },
                colorSchemeValue:
                  action.payload.data.data.colorSchemeValue || "standard",
              }
            : getDefaultChartConfigDataPayload(),
        },
      };
    /**
     * Atualizando configurações de fontes de gráficos evolutivos
     */
    case withPending(UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    case withFulFilled(UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        evolutiveChartConfigData: {
          ...state.evolutiveChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.evolutiveChartConfigData.payload,
            fontsSizes: action.payload.newFontsSizes,
          },
        },
      };

    /**
     * update das configurações de cores do gráfico evolutivo de cruzamentos
     */
    case withPending(UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: true,
          error: false,
        },
      };

    case withRejected(UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: false,
          error: action.payload,
          payload: {
            ...state.evolutiveCrossChartConfigData.fetchedPayload,
            chartsColors: {
              ...state.evolutiveCrossChartConfigData.fetchedPayload
                .chartsColors,
            },
          },
        },
      };
    case withFulFilled(UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: false,
          error: false,
          apiHasNoConfigs: false,
          payload: {
            ...action.payload.newData,
            chartsColors: { ...action.payload.newData.chartsColors },
          },
          fetchedPayload: state.evolutiveCrossChartConfigData.payload,
          colorPickerColors: action.payload.newColorsArray,
        },
      };

    /**
     * Fetch das configurações do gráfico evolutivo
     */
    case withPending(FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: false,
          error: colorConfigErrorMessage,
          payload: getDefaultChartConfigDataPayload(),
          fetchedPayload: getDefaultChartConfigDataPayload(),
        },
      };
    case withFulFilled(FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          error: false,
          running: false,
          apiHasNoConfigs: !action.payload.data.data,
          payload: action.payload.data.data
            ? {
                ...action.payload.data.data,
                chartsColors: {
                  ...action.payload.data.data.chartsColors,
                },
                colorSchemeValue:
                  action.payload.data.data.colorSchemeValue || "standard",
              }
            : getDefaultChartConfigDataPayload(),
          fetchedPayload: action.payload.data.data
            ? {
                ...action.payload.data.data,
                chartsColors: {
                  ...action.payload.data.data.chartsColors,
                },
                colorSchemeValue:
                  action.payload.data.data.colorSchemeValue || "standard",
              }
            : getDefaultChartConfigDataPayload(),
        },
      };
    /**
     * Atualizando configurações de fontes de gráficos evolutivos
     */
    case withPending(UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    case withFulFilled(UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        evolutiveCrossChartConfigData: {
          ...state.evolutiveCrossChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.evolutiveCrossChartConfigData.payload,
            fontsSizes: action.payload.newFontsSizes,
          },
        },
      };

    /**
     * Carregando dados de configuração
     */
    case withPending(FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA):
      return fetchSimpleCrossChartColorConfigDataPending(state);
    case withRejected(FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA):
      return fetchSimpleCrossChartColorConfigDataRejected(state, action);
    case withFulFilled(FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA):
      return fetchSimpleCrossChartColorConfigDataFulFilled(state, action);
    /**
     * Atualização das configurações de fontes na API
     *
     */
    case withPending(UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA):
      return updateSimpleCrossChartFontSizePending(state, action);
    case withFulFilled(UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA):
      return updateSimpleCrossChartFontSizeFulfilled(state, action);
    case withRejected(UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA):
      return updateSimpleCrossChartFontSizeRejected(state, action);

    /**
     * Atualização da configuração de cores na API
     */
    case withPending(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA):
      return updateSimpleCrossChartDataPending(state, action);
    case withFulFilled(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA):
      return updateSimpleCrossChartDataFulfulled(state, action);
    case withRejected(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA):
      return updateSimpleCrossChartDataRejected(state, action);
    // simple chart config data (GET) reducers
    case withPending(FETCH_SIMPLE_CHART_COLOR_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(FETCH_SIMPLE_CHART_COLOR_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          payload: {
            ...getDefaultChartConfigDataPayload(),
          },
          fetchedPayload: {
            ...getDefaultChartConfigDataPayload(),
          },
          running: false,
          error: colorConfigErrorMessage,
        },
      };
    case withFulFilled(FETCH_SIMPLE_CHART_COLOR_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          apiHasNoConfigs: !action.payload.data,
          running: false,
          payload: {
            ...(action.payload.data
              ? {
                  ...action.payload.data,
                  colorSchemeValue:
                    action.payload.data.colorSchemeValue || "standard",
                }
              : {
                  ...getDefaultChartConfigDataPayload(),
                }),
          },
          fetchedPayload: {
            ...(action.payload.data
              ? {
                  ...action.payload.data,
                  chartsColors: { ...action.payload.data.chartsColors },
                  colorSchemeValue:
                    action.payload.data.colorSchemeValue || "standard",
                }
              : {
                  ...getDefaultChartConfigDataPayload(),
                }),
          },
        },
      };
    // simple chart config colors (PUT) reducers
    case withPending(UPDATE_CHART_COLOR_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(UPDATE_CHART_COLOR_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          running: false,
          error: action.payload,
          payload: state.chartConfigData.fetchedPayload,
        },
      };
    // Adicionado o payload da action para atualizar as cores
    // do estado de configuracao de cores dos graficos do redux
    case withFulFilled(UPDATE_CHART_COLOR_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.chartConfigData.payload,
            chartsColors: { ...action.payload.newData.chartsColors },
          },
          // aqui ele atualiza as cores carregadas da api com a nova configuracao de cores
          // que foi submetida para lá
          fetchedPayload: {
            ...state.chartConfigData.payload,
            chartsColors: { ...state.chartConfigData.payload.chartsColors },
          },
          // aqui ele atualiza as cores do colorpicker com o novo array de cores ordenado
          // de acordo com as ultimas seleções
          ...(action.payload.newColorsArray
            ? { colorPickerColors: action.payload.newColorsArray }
            : {}),
        },
      };

    // chart config fontsizes (PUT) reducers
    case withPending(UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          running: false,
          error: action.payload,
        },
      };
    // Adicionado o payload da action para atualizar as fontes
    // do estado de configuracao dos graficos do redux
    case withFulFilled(UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        chartConfigData: {
          ...state.chartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          // Atualizando os payloads com as novas configurações de fonte.
          fetchedPayload: {
            ...state.chartConfigData.fetchedPayload,
            fontsSizes: action.payload.newFontsSizes,
          },
          payload: {
            ...state.chartConfigData.payload,
            fontsSizes: action.payload.newFontsSizes,
          },
        },
      };
    // simple chart
    case withPending(FETCH_SIMPLE_CHART_DATA):
      return { ...state, simpleChartData: { running: true } };
    case withRejected(FETCH_SIMPLE_CHART_DATA):
      return {
        ...state,
        simpleChartData: { running: false, error: action.payload },
      };
    case withFulFilled(FETCH_SIMPLE_CHART_DATA):
      return {
        ...state,
        simpleChartData: { running: false, payload: action.payload.data },
      };
    // simple cross chart
    case withPending(FETCH_SIMPLE_CROSS_CHART_DATA):
      return { ...state, simpleCrossChartData: { running: true } };
    case withRejected(FETCH_SIMPLE_CROSS_CHART_DATA):
      return {
        ...state,
        simpleCrossChartData: { running: false, error: action.payload },
      };
    case withFulFilled(FETCH_SIMPLE_CROSS_CHART_DATA):
      return {
        ...state,
        simpleCrossChartData: { running: false, payload: action.payload.data },
      };
    // multi cross chart
    case withPending(FETCH_MULTI_CROSS_CHART_DATA):
      return { ...state, multiCrossChartData: { running: true } };
    case withRejected(FETCH_MULTI_CROSS_CHART_DATA):
      return {
        ...state,
        multiCrossChartData: { running: false, error: action.payload },
      };
    case withFulFilled(FETCH_MULTI_CROSS_CHART_DATA):
      return {
        ...state,
        multiCrossChartData: {
          running: false,
          payload: action.payload.data ? action.payload.data[0] : [],
        },
      };
    // multi cross chart config data (GET)
    case withPending(FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA):
      return fetchMultiCrossingChartConfigDataPending(state, action);
    case withFulFilled(FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA):
      return fetchMultiCrossingChartConfigDataFulfilled(state, action);
    case withRejected(FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA):
      return fetchMultiCrossingChartConfigDataRejected(state, action);
    // multi cross chart config data (POST/PUT UPDATE)
    case withPending(UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA):
      return updateMultipleCrossChartDataPending(state, action);
    case withFulFilled(UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA):
      return updateMultipleCrossChartDataFulfulled(state, action);
    case withRejected(UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA):
      return updateMultipleCrossChartDataRejected(state, action);
    // evolutive chart
    case withPending(FETCH_EVOLUTIVE_CHART_DATA):
      return { ...state, evolutionChartData: { running: true } };
    case withRejected(FETCH_EVOLUTIVE_CHART_DATA):
      return {
        ...state,
        evolutionChartData: { running: false, error: action.payload },
      };
    case withFulFilled(FETCH_EVOLUTIVE_CHART_DATA):
      return {
        ...state,
        evolutionChartData: { running: false, payload: action.payload.data },
      };
    // correlation chart
    case withPending(FETCH_CORRELATION_CHART_DATA):
      return { ...state, correlationChartData: { running: true } };
    case withRejected(FETCH_CORRELATION_CHART_DATA):
      return {
        ...state,
        correlationChartData: { running: false, error: action.payload },
      };
    case withFulFilled(FETCH_CORRELATION_CHART_DATA):
      return {
        ...state,
        correlationChartData: {
          running: false,
          payload: action.payload.data,
          type: action.meta.fetchType,
        },
      };
    // simulation chart
    case withPending(FETCH_SIMULATION_CHART_DATA):
      return {
        ...state,
        simulationChartData: { running: true, error: null, payload: null },
      };
    case withRejected(FETCH_SIMULATION_CHART_DATA):
      return {
        ...state,
        simulationChartData: {
          running: false,
          error: action.payload,
          payload: null,
        },
      };
    case withFulFilled(FETCH_SIMULATION_CHART_DATA):
      return {
        ...state,
        simulationChartData: {
          running: false,
          error: null,
          payload: action.payload.data,
          type: action.meta.fetchType,
        },
      };
    //
    case withPending(FETCH_PREDICT_EVOLUTIVE_CHART_DATA):
      return {
        ...state,
        predictiveChartData: { running: true, error: null, payload: null },
      };
    case withRejected(FETCH_PREDICT_EVOLUTIVE_CHART_DATA):
      return {
        ...state,
        predictiveChartData: {
          running: false,
          error: action.payload,
          payload: null,
        },
      };
    case withFulFilled(FETCH_PREDICT_EVOLUTIVE_CHART_DATA):
      return {
        ...state,
        predictiveChartData: {
          running: false,
          error: null,
          payload: action.payload.data,
          type: action.meta.fetchType,
        },
      };
    // calculate new simulation
    case withPending(CALCULATE_SIMULATION_CHART_DATA):
      return {
        ...state,
        simulationChartData: { running: true, error: null, payload: null },
      };
    case withRejected(CALCULATE_SIMULATION_CHART_DATA):
      return {
        ...state,
        simulationChartData: {
          running: false,
          error: action.payload,
          payload: null,
        },
      };
    case withFulFilled(CALCULATE_SIMULATION_CHART_DATA): {
      const payloadData = action.payload.data;
      if (payloadData.error) {
        return {
          ...state,
          simulationChartData: { running: false, error: payloadData.error },
        };
      }
      return {
        ...state,
        simulationChartData: {
          running: false,
          error: null,
          payload: payloadData,
          type: action.meta.fetchType,
        },
      };
    }
    // reseting error
    case CALCULATE_SIMULATION_CHART_DATA:
      return { ...state, simulationChartData: { running: false, error: null } };
    /**
     * Fetch das configurações de cores do gráfico de correlação
     */
    case withPending(FETCH_CORRELATION_CHART_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(FETCH_CORRELATION_CHART_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: false,
          error: colorConfigErrorMessage,
          payload: getDefaultChartConfigDataPayload(),
          fetchedPayload: getDefaultChartConfigDataPayload(),
        },
      };
    case withFulFilled(FETCH_CORRELATION_CHART_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          error: false,
          running: false,
          apiHasNoConfigs: !action.payload.data.data,
          payload: action.payload.data.data
            ? {
                ...action.payload.data.data,
                chartsColors: {
                  ...action.payload.data.data.chartsColors,
                },
              }
            : getDefaultChartConfigDataPayload(),
          fetchedPayload: action.payload.data.data
            ? {
                ...action.payload.data.data,
                chartsColors: {
                  ...action.payload.data.data.chartsColors,
                },
              }
            : getDefaultChartConfigDataPayload(),
        },
      };
    /**
     * Update das configurações de cores do gráfico de correlação
     */
    case withPending(UPDATE_CORRELATION_COLOR_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(UPDATE_CORRELATION_COLOR_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: false,
          error: action.payload,
          payload: {
            ...state.correlationChartConfigData.fetchedPayload,
            chartsColors: {
              ...state.correlationChartConfigData.fetchedPayload.chartsColors,
            },
          },
        },
      };
    case withFulFilled(UPDATE_CORRELATION_COLOR_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: false,
          error: false,
          apiHasNoConfigs: false,
          payload: {
            ...action.payload.newData,
            chartsColors: { ...action.payload.newData.chartsColors },
          },
          fetchedPayload: state.correlationChartConfigData.payload,
          colorPickerColors: action.payload.newColorsArray,
        },
      };
    /**
     * Update do tamanho de fonte do gráfico de correlação
     */
    case withPending(UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: true,
          error: false,
        },
      };
    case withRejected(UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    case withFulFilled(UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.correlationChartConfigData.payload,
            fontsSizes: action.payload.newFontsSizes,
          },
        },
      };
    /**
     * Update do esquema de cores do gráfico de correlação (padrão/neutro)
     */
    case withPending(UPDATE_CORRELATION_CHART_COLOR_SCHEME):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: true,
          error: false,
        },
      };
    case withFulFilled(UPDATE_CORRELATION_CHART_COLOR_SCHEME):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          apiHasNoConfigs: false,
          running: false,
          error: false,
          payload: {
            ...state.correlationChartConfigData.payload,
            chartsColors: action.payload.newChartsColors,
            colorSchemeValue: action.payload.newColorScheme,
          },
        },
      };
    case withRejected(UPDATE_CORRELATION_CHART_COLOR_SCHEME):
      return {
        ...state,
        correlationChartConfigData: {
          ...state.correlationChartConfigData,
          running: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default execute;
